<div [innerHTML]="message" mat-dialog-content>
</div>
<div mat-dialog-actions>
	<button mat-button [mat-dialog-close]="true" class="confirm">Okay !!!</button>
</div>